import axios from "axios";
import { API_URL } from "../utils/Constant";

const getBatchReportsSearchQueryString = (search) => {
  const trimmedSearch = search.trim();
  if (!trimmedSearch) {
    return "";
  }
  return `&search=${encodeURIComponent(trimmedSearch)}`;
};

export const postBatchReports = async (
  payload,
  date,
  reportDate,
  receivedDate,
  generatePartial,
  partialResults,
  user_id = null,
  frontend_log_data = null,
) => {
  if (reportDate === "Invalid date") reportDate = "";
  if (receivedDate === "Invalid date") receivedDate = "";

  if (generatePartial) {
    try {
      const response = await axios.post(`${API_URL}/generatebatchreports/`, {
        date: reportDate || date,
        received_date: receivedDate,
        is_partial: "False",
        list: payload,
        disableRunQc: false,
        user_id,
        frontend_log_data,
      });

      const data = await response.data;
      return { success: true, ...data };
    } catch (e) {
      const message = e?.response?.data?.message || "Something went wrong.";
      return { success: false, message };
    }
  } else if (partialResults) {
    try {
      const response = await axios.post(`${API_URL}/generatebatchreports/`, {
        date: reportDate || date,
        received_date: receivedDate,
        is_partial: "True",
        list: payload,
        disableRunQc: false,
        user_id,
        frontend_log_data,
      });

      const data = await response.data;
      return { success: true, ...data };
    } catch (e) {
      const message = e?.response?.data?.message || "Something went wrong.";
      return { success: false, message };
    }
  } else {
    try {
      const response = await axios.post(`${API_URL}/generatebatchreports/`, {
        date: reportDate || date,
        received_date: receivedDate,
        is_partial: "False",
        list: payload,
        disableRunQc: false,
        user_id,
        frontend_log_data,
      });

      const data = await response.data;
      return { success: true, ...data };
    } catch (e) {
      const message = e?.response?.data?.message || "Something went wrong.";
      return { success: false, message };
    }
  }
};

export const generateParitailTestReports = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/generatebatchreports/`, { ...payload, disableRunQc: false });
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message || "Something went wrong.";
    return { success: false, message };
  }
};

export const updateStatusBatchReports = async (status, payload) => {
  try {
    let response = await axios.post(`${API_URL}/updatewostatus/`, {
      status,
      wo_id_list: payload,
    });

    let data = await response.data;

    if (response.status === 207) {
      return {
        success: false,
        status207: true,
        message: data.message.trim(),
        result: data.result,
      };
    }

    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message || "Something went wrong.";
    return { success: false, message };
  }
};

export const deleteWoSampleTest = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/editsample/`, payload);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message || "Something went wrong. ";
    return { success: false, message };
  }
};

export const editWoCustomer = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/editcustomerinsample/`, payload);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong. ";
    return { success: false, message };
  }
};

export const getBatchReports = async (date, category, view, signal = null, search = "") => {
  try {
    const response = await axios.get(
      `${API_URL}/getwosbatchreports/?date=${date}&category=${category}&view=${view}${getBatchReportsSearchQueryString(search)}`,
      { signal },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something went wrong", canceled: e.code === "ERR_CANCELED" };
  }
};

export const getBatchReportsOverDue = async (view, signal = null, search = "") => {
  try {
    const response = await axios.get(
      `${API_URL}/getwosbatchreports/?date=&category=overdue&view=${view}${getBatchReportsSearchQueryString(search)}`,
      { signal },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something went wrong", canceled: e.code === "ERR_CANCELED" };
  }
};

/**
 * This api is used to get the overdue results with all test data
 */
export const getExportBatchReportsOverDueInfoList = async (view, signal = null) => {
  try {
    const response = await axios.get(
      `${API_URL}/getwosbatchreportsexport/?date=&category=overdue&view=${view}`,
      { signal },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something went wrong", canceled: e.code === "ERR_CANCELED" };
  }
};

export const getExportBatchReportsReadyInfoList = async (view, signal = null) => {
  try {
    const response = await axios.get(
      `${API_URL}/getwosbatchreportsexport/?date=&category=ready&view=${view}`,
      { signal },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something went wrong", canceled: e.code === "ERR_CANCELED" };
  }
};

export const getBatchReportsFilter = async (
  filter,
  date,
  checkReadyResults,
  checkOverDueResults,
  checkDueByResults,
  checkDueByResultsDate,
  view,
  signal = null,
  search = "",
) => {
  const searchQueryString = getBatchReportsSearchQueryString(search);
  try {
    let response;
    if (checkReadyResults) {
      response = await axios.get(
        `${API_URL}/getwosbatchreports/?date=&category=ready&filter=${filter}&view=${view}${searchQueryString}`,
        { signal },
      );
    } else if (checkOverDueResults) {
      response = await axios.get(
        `${API_URL}/getwosbatchreports/?date=&category=overdue&filter=${filter}&view=${view}${searchQueryString}`,
        { signal },
      );
    } else if (checkDueByResults) {
      response = await axios.get(
        `${API_URL}/getwosbatchreports/?date=${checkDueByResultsDate}&category=dueby&filter=${filter}&view=${view}${searchQueryString}`,
        { signal },
      );
    } else {
      response = await axios.get(
        `${API_URL}/getwosbatchreports/?date=${date}&category=&filter=${filter}&view=${view}${searchQueryString}`,
        { signal },
      );
    }
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something went wrong", canceled: e.code === "ERR_CANCELED" };
  }
};

export const getBatchReportsReady = async (view, signal = null, search = "") => {
  try {
    const response = await axios.get(
      `${API_URL}/getwosbatchreports/?date=&category=ready&view=${view}${getBatchReportsSearchQueryString(search)}`,
      { signal },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something went wrong", canceled: e.code === "ERR_CANCELED" };
  }
};

export const getSearchOptions = async () => {
  try {
    const response = await axios.get(`${API_URL}/customerinfo/?search=&status=1`);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Failed to load company names for search." };
  }
};

export const getPesticideCompounds = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/fetchupdatecompound/`, payload);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something Went wrong" };
  }
};

export const deletePesticideCompounds = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/fetchupdatecompound/`, payload);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something Went wrong" };
  }
};

export const savePesticideCompounds = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/fetchupdatecompound/`, payload);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something Went wrong" };
  }
};

/**
 * This api is used to get the detail information of a workorder
 * @param {*} params { wo_id: number}
 * @param {*} signal
 * @returns {Object} { success: Boolean, info_list: {}[], message, canceled, wo_id: string, customer_name: string }
 */
export const getBatchReportDetail = async (params, signal = null) => {
  try {
    const response = await axios.get(
      `${API_URL}/getwoinfolist/`,
      { params, signal },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something went wrong", canceled: e.code === "ERR_CANCELED" };
  }
};

/**
 * Get work order details (stages, samples, metadata) for WO details modal
 * @param {{ workorder: number, genista_id?: string }} params - workorder: work order primary key
 * @param {AbortSignal} signal
 * @returns {Object} { success: Boolean, data?: Object, message?: string, canceled?: boolean }
 */
export const getWoInfo = async (params, signal = null) => {
  try {
    const response = await axios.get(`${API_URL}/get_wo_info/`, { params, signal });
    const resData = response.data;
    if (resData?.message === "Successful" && resData?.data) {
      return { success: true, data: resData.data };
    }
    return { success: false, message: resData?.message || "Failed to load work order details." };
  } catch (e) {
    return {
      success: false,
      message: e?.response?.data?.message || e?.message || "Failed to load work order details.",
      canceled: e.code === "ERR_CANCELED",
    };
  }
};
